module.exports = __webpack_public_path__ + "img/PT79.b808f273.png";